import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import { forgotPasswordService } from 'src/redux/auth/apis';

const ForgotPassword = () => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validate: (values) => {
      const errors: any = {};

      if (!values.email) {
        errors.email = '* Requerido';
      }

      return errors;
    },
    onSubmit: async (values) => {
      setError(false);
      setSuccess(false);
      try {
        await forgotPasswordService({
          email: values.email,
        });
        setSuccess(true);
      } catch (error) {
        setError(true);
      }
    },
  });

  return (
    <div className='h-screen flex items-center justify-center'>
      <div className='flex flex-col max-w-md p-6 rounded-md sm:p-10 darkNot:bg-gray-900 darkNot:text-gray-100 shadow-lg border w-96'>
        <div className='mb-8 text-center'>
          <h1 className='my-3 text-2xl font-bold'>Recuperar cuenta</h1>
        </div>

        {!success && (
          <form onSubmit={formik.handleSubmit} className='space-y-12'>
            <div className='space-y-4'>
              <div>
                <label htmlFor='email' className='block mb-2 text-sm'>
                  Correo electrónico{' '}
                </label>
                <input
                  type='email'
                  name='email'
                  id='email'
                  placeholder='email@tuhabi.mx'
                  className='w-full px-3 py-3 border rounded-md darkNot:border-gray-700 darkNot:bg-gray-900 darkNot:text-gray-100'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
                {formik.errors.email && formik.touched.email && (
                  <div className='text-red-500 mt-1'>{formik.errors.email}</div>
                )}
              </div>
            </div>
            <div className='space-y-2'>
              {error && (
                <div className='flex flex-row !mt-12 mb-4 pl-4 py-2 gap-2 items-center border border-red-600 rounded-lg shadow overflow-hidden darkNot:bg-gray-900 darkNot:border-violet-400'>
                  <span className='flex-shrink-0 inline-flex mx-0 item-center justify-center leadi rounded-full darkNot:bg-violet-400 darkNot:text-gray-900'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      viewBox='0 0 20 20'
                      fill='currentColor'
                      className='h-8 w-8 fill-red-500'
                    >
                      <path
                        fillRule='evenodd'
                        d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z'
                        clipRule='evenodd'
                      ></path>
                    </svg>
                  </span>
                  <div className='flex-1 p-2'>
                    <p className='text-sm darkNot:text-gray-100'>
                      Lo sentimos, hubo un error. <br /> Inténtalo de nuevo.
                    </p>
                  </div>
                </div>
              )}
              <div>
                <button
                  type='submit'
                  className='w-full px-8 py-3 font-semibold bg-purple-600 text-white rounded-md darkNot:bg-violet-400 darkNot:text-gray-900'
                >
                  Restablecer cuenta
                </button>
                <Link
                  to='/login'
                  className='w-full flex items-center justify-center mt-4 px-8 py-3 font-semibold border border-purple-600 text-purple-600 rounded-md darkNot:bg-violet-400 darkNot:text-gray-900'
                >
                  Iniciar sesión
                </Link>
              </div>
            </div>
          </form>
        )}
        {success && (
          <div>
            <p>
              Revisa tu correo electrónico <b>{formik.values.email}</b>
            </p>
            <Link
              to='/login'
              className='mt-12 w-full flex items-center justify-center px-8 py-3 font-semibold border border-purple-600 text-purple-600 rounded-md darkNot:bg-violet-400 darkNot:text-gray-900'
            >
              Iniciar sesión
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
